import React, { Component } from 'react';
import { Row, Select, InputNumber, Button, message, Spin } from 'antd';
import moment from 'moment';
import './index.scss'

const { Option } = Select;

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dateData: [],
            date: moment().add(1, 'y').format('YYYY'),
            loading: true,
            data: {
                money: 0,
            },
            loadingSave: false,
        }
    }

    componentDidMount() {
        let date = Number(this.state.date || "0");
        let dateData = [];
        let len = date - 2018 + 3;
        for (let i = 0; i < len; i++) {
            dateData.push((2018 + i).toString())
        }
        this.setState({ dateData });
        this.getData(this.state.date)
    }

    getData = (date) => {
        fetch(`/extrapProfitInfo?year=${date}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            this.setState({
                data: { money: 0, ...x.data }
            })
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
        this.setState({
            loading: false
        })
    }

    onSave = () => {
        let data = this.state.data;
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let dataFrom = new FormData();
        data = { ...data, year }
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/extrapProfitAdd', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            message.error('保存失败！');
            console.error(err);
        })
    }

    render() {
        const { data } = this.state;
        return (
            <div className='profit'>
                <Spin spinning={this.state.loading}>
                    <Row className='title'>情况分析利润调整</Row>
                    <Row className="table-month">
                        <Select
                            placeholder="请选择年份"
                            style={{ width: 120 }}
                            value={this.state.date}
                            onChange={(str) => {
                                console.log(str);
                                this.setState({
                                    date: str,
                                    loading: true
                                });
                                this.getData(str)
                            }}
                        >
                            {this.state.dateData.map((x, i) => {
                                return (
                                    <Option value={x} key={x}>{x}年</Option>
                                )
                            })}
                        </Select>
                    </Row>
                    <Row>
                        <InputNumber
                            className='input'
                            value={data.money || 0}
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            onChange={(e) => {
                                let newData = data;
                                newData.money = e;
                                this.setState({
                                    data: newData
                                })
                            }}
                        />
                    </Row>
                    <Row><Button type="primary" onClick={this.onSave} loading={this.state.loadingSave}>保存</Button></Row>
                </Spin>
            </div>
        )
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/BI/profit/index.js